import {SetErrorModalScreen} from "../../../../../redux/ConnectorWrapper";

export function HideUpdateModal(props: any) {
    SetErrorModalScreen(props,{});
}

export function ShowUpdateModal(props: any, label: string, content: string) {
    SetErrorModalScreen(props, {show:true, label: label, content: content});
}
